module.exports = __webpack_public_path__ + "img/d20061016-3.f0778584.jpg";